import type { GlobalAttributesT } from '@elliemae/ds-props-helpers';
import { DSSwipeCard } from '@elliemae/ds-swipe-card';
import { styled } from '@elliemae/ds-system';
import { DSTabsName, TABS_SLOTS } from '../../constants/index.js';

interface StyledPanelContainerPropsT {
  hide: boolean;
  isDSMobile: boolean;
}
export interface PanelDescriptor extends Record<string, unknown> {
  index: number;
  tabId: string;
  isActive: boolean;
  isDSMobile: boolean;
  content: React.ReactNode;
  style: React.CSSProperties;
  tabPanelsProps?: GlobalAttributesT<HTMLDivElement>;
  'aria-hidden': boolean;
  'data-panel-id': string;
  'data-testid': string;
  hide: boolean;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  role: 'tabpanel';
}

export const StyledPanelContainer = styled('div', {
  name: DSTabsName,
  slot: TABS_SLOTS.TAB_PANEL,
})<StyledPanelContainerPropsT>`
  flex: 1 1 auto;
  min-height: 0;
  padding-top: 8px;
  &:focus {
    outline: none;
  }

  ${({ isDSMobile }) => (isDSMobile ? `padding-top: 0;` : ``)}
`;

export const StyledDSSwipeCard = styled(DSSwipeCard<PanelDescriptor>, {
  name: DSTabsName,
  slot: TABS_SLOTS.TABS_SWIPE_CARD,
})``;
